export default __webpack_public_path__ + "697087b5cb08f4047487a441cb21a448.svg";